<template>
  <div id="qualita">
  
    <h1 class="font-weight-light w3-serif quality-title-color ml-12">
      La nostra qualità
    </h1>
    <br>
    <div class="d-flex flex-wrap justify-space-around mb-8">

      <v-card class="mx-auto mb-4" max-width="30%">
        <v-card-title class="white--text primary dark">
          {{experience.title}}
          <v-spacer></v-spacer>
          <span class="material-icons">{{experience.icon}}</span>
        </v-card-title>
        <v-card-text class="text--primary pt-4 pb-4"> 
          {{experience.description}}
        </v-card-text>
        <div class="d-flex justify-center align-center mt-4 mb-4">
          <img :src="experience.imageSrc" :width="experience.imageWidth">
        </div>
      </v-card>

      <v-card class="mx-auto mb-4" max-width="30%">
        <v-card-title class="white--text primary dark">
          {{certification.title}}
          <v-spacer></v-spacer>
          <span class="material-icons">{{certification.icon}}</span>
        </v-card-title>
        <v-card-text class="text--primary pt-4 pb-4">
          Abbiamo ottenuto l'attestato <strong>SOA OG1 III-BIS</strong> e <strong>OG2 III-BIS</strong> numero 72600/10/00 il 22/05/2024, dimostrando la nostra competenza tecnica ed economica per importanti lavori pubblici. 
          Inoltre, siamo certificati secondo la norma <strong>ISO 9001:2015 (Certificato n. IC-QM-2312002)</strong> per la costruzione, ristrutturazione e restauro di edifici, con ricertificazione prevista entro il 30/11/2026.",
        </v-card-text>
        <v-divider class="mt-0 mb-0"></v-divider>
        <v-card-text class="text--primary">
          {{certification.info}}
        </v-card-text>
        <v-card-text class="pt-0 pb-2 text-center">
          <a :href="certification.imageHref" target="_blank">
            <img :src="certification.imageSrc" :width="certification.imageWidth">
          </a>
        </v-card-text> 
        <v-card-text class="pt-0 pb-2 text-center">
          <a :href="certification.imageHref2" target="_blank">
            <img :src="certification.imageSrc2" :width="certification.imageWidth">
          </a>
        </v-card-text>    
      </v-card>

      <v-card class="mx-auto mb-4" max-width="30%">
        <v-card-title class="white--text primary dark">
          {{provider.title}}
          <v-spacer></v-spacer>
          <span class="material-icons">{{provider.icon}}</span>
        </v-card-title>
        <v-card-text class="text--primary pt-4 pb-4">
          {{provider.description}}
        </v-card-text>
        <v-divider class="mt-0 mb-0"></v-divider>
        <v-card-text class="text--primary">
          {{provider.info}}
          <a :href="provider.imageHref2" target="_blank">
            <img :src="provider.imageSrc" :width="provider.imageWidth">
          </a>
        </v-card-text>    
      </v-card>
    </div>

  </div>

</template>

<script>
  export default {
    name: 'Qualita',
    data: () => ({
      experience:{
        title: "Esperienza",
        icon: "account_balance",
        description: "Da oltre 20 anni opera sul patrimonio edilizio esistente, perseguendo una filosofia conservativa ed adottando tecniche riprese dalla tradizione accanto a sistemi e prodotti innovativi.",
        imageSrc: require("../assets/esperienza.png"),
        imageWidth: "30%",
      },
      certification:{
        title: "Qualità certificata",
        icon: "verified",
        info: "Per saperne di più consulta: ",
        imageSrc: require("../assets/certificazione.png"),
        imageSrc2: require("../assets/intercert.jpg"),
        imageWidth: "40%",
        imageHref: "https://www.cqop.it/",
        imageHref2: "https://intercertitalia.it/",
      },
      provider:{
        title: "Fornitori",
        icon: "local_shipping",
        description: "Abbiamo la fiducia dei più importanti produttori di materiali.",          
        info: "Per maggiori informazioni: ",
        imageSrc: require("../assets/springColor2.png"),
        imageWidth: "40%",
        imageHref: "https://www.springcolor.it/",
      }
    }),
  }
</script>

<style>
  .quality-title-color{
    color: black;
  }
</style>